export default "__VITE_ASSET__CnWbpDsA__"